import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function RHFAutocomplete({
  name,
  label,
  placeholder,
  helperText,
  defaultValue, // Added defaultValue prop
  onChange, // Added onChange prop
  ...other
}) {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          onChange={(event, newValue) => {
            if (onChange) {
              onChange(event, newValue); // Trigger the onChange prop if provided
            } else {
              setValue(name, newValue, { shouldValidate: true });
            }
          }}
          renderInput={params => (
            <TextField
              label={label}
              placeholder={placeholder}
              error={!!error}
              helperText={error ? error?.message : helperText}
              {...params}
            />
          )}
          defaultValue={defaultValue || null} // Set defaultValue prop
          {...other}
        />
      )}
    />
  );
}

RHFAutocomplete.propTypes = {
  helperText: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.any, // Add prop type for defaultValue
  onChange: PropTypes.func, // Add prop type for onChange
};
